import React, {useEffect, useState} from "react";
import {inIframe, isMobile} from "../Setting";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, EffectFade} from "swiper/modules";

function RsoBgContainer({
  delay,
  hasGallery,
  gallery,
  isDarkMode,
  formBackgroundUrlMobile,
  formBackgroundUrl,
  formBackgroundColor,
  mobileGalleryItems,
  mobileGalleryDelay,
  hasMobileGallery,
  children,
}) {
  console.log("formBackgroundColor", formBackgroundColor);
  const [bgStatus, setBgStatus] = useState("loading");
  const [apiBgStyle, setApiBgStyle] = useState({});

  const isMob = isMobile();
  const showDesktopSlider = !isMob && hasGallery && gallery?.length > 1;
  const showMobileSlider = isMob && hasMobileGallery && mobileGalleryItems?.length > 1;

  useEffect(() => {
    setBgStatus("loading");

    let targetUrl = undefined;
    if (showDesktopSlider || showMobileSlider) {
      targetUrl = showDesktopSlider ? gallery?.[0] : mobileGalleryItems?.[0];
    } else if (!inIframe()) {
      targetUrl = isMob ? formBackgroundUrlMobile : formBackgroundUrl;
    }
    if (targetUrl) {
      const img = new Image();
      img.src = targetUrl;

      img.onload = () => {
        if (!showDesktopSlider && !showMobileSlider) {
          setApiBgStyle({
            backgroundImage: `url("${encodeURI(targetUrl)}")`,
          });
        }
        setBgStatus("api");
      };

      img.onerror = () => {
        if (formBackgroundColor) {
          setApiBgStyle({
            backgroundImage: "none",
            backgroundColor: formBackgroundColor,
          });
          setBgStatus("api");
        } else {
          setBgStatus("default");
        }
      };
    } else if (formBackgroundColor) {
      setApiBgStyle({
        backgroundImage: "none",
        backgroundColor: formBackgroundColor,
      });
      setBgStatus("api");
    } else {
      setBgStatus("default");
    }
  }, [showDesktopSlider, showMobileSlider, gallery, mobileGalleryItems, formBackgroundUrl, formBackgroundUrlMobile, isMob]);

  const defaultBgClass = bgStatus === "default"
    ? (isDarkMode ? "login-background-dark" : "login-background")
    : "";

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        minHeight: "100vh",
        overflow: "hidden",
        flex: "auto",
        display: "flex",
        alignItems: "center",
        height: "100%",
        backgroundColor: isDarkMode ? "#141414" : "#ffffff",
      }}
    >
      <div
        className={defaultBgClass}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 0,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          ...(bgStatus === "api" ? apiBgStyle : {}),
          opacity: bgStatus === "loading" ? 0 : 1,
          transition: "opacity 1s ease-in-out",
        }}
      >
        {showDesktopSlider && bgStatus === "api" && (
          <Swiper
            modules={[EffectFade, Autoplay]}
            autoplay={{delay: delay * 1000 || 2500, disableOnInteraction: false}}
            effect="fade"
            loop={true}
            allowTouchMove={false}
            simulateTouch={false}
            style={{height: "100%"}}
          >
            {gallery.map((url, el) => (
              <SwiperSlide key={el}>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    backgroundImage: `url("${encodeURI(url)}")`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        )}

        {showMobileSlider && bgStatus === "api" && (
          <Swiper
            modules={[EffectFade, Autoplay]}
            autoplay={{delay: mobileGalleryDelay * 1000 || 2500, disableOnInteraction: false}}
            effect="fade"
            loop={true}
            allowTouchMove={false}
            simulateTouch={false}
            style={{height: "100%"}}
          >
            {mobileGalleryItems.map((url, el) => (
              <SwiperSlide key={el}>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    backgroundImage: `url("${encodeURI(url)}")`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
      {children}
    </div>
  );
}

export default RsoBgContainer;
